<template>
  <div class="registration" ref="registration">
    <div class="header">
      <div class="back" @click="back()">
        <div>返回</div>
        <p>注册</p>
      </div>
      <div class="tips">
        <div>注册</div>
      </div>
    </div>

    <div class="zhuce-box">
      <span>企业全称</span>
      <div class="input-box">
        <input class="vux-x-input" :class="{ errorTips: memNameTs }" placeholder="请输入" v-model="signInInfo.memName"
          :maxlength="50" @focus="memNameTs = false" />
      </div>

      <span>您的姓名</span>

      <div class="input-box">
        <input class="vux-x-input" :class="{ errorTips: linkManTs }" ref="nameinput" placeholder="请输入"
          v-model="signInInfo.linkMan" :maxlength="8" @focus="linkManTs = false" />
      </div>

      <span>企业地址</span>
      <div class="input-box">
        <input class="vux-x-input" :class="{ errorTips: addressTs }" placeholder="请输入" v-model="signInInfo.address"
          :maxlength="100" @focus="addressTs = false" />
      </div>
    </div>
    <div class="bottom-box">

      <van-button class="btn-login" type="primary" @click="btn()">注册</van-button>
      <!-- <span class="btn" @click.stop="btn()">注册</span> -->
      <div class="xy-box">
        <b :class="agreement ? 'on' : ''" @click="
          agreement = !agreement;
        pleaseCheked = false;
        "></b>
        我已阅读并同意<a @click="$router.push('/user/agreement')">《用户协议》</a><a
          @click="$router.push('/user/privacyPolicy')">《隐私协议》 </a>
      </div>
      <div class="please-checked" v-if="pleaseCheked">请勾选同意协议</div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  name: "registration",
  data() {
    return {
      signInInfo: {
        memName: "", // 企业名称
        linkMan: "", // 您的姓名
        address: "", // 企业地址
      },
      agreement: false, // 协议
      memNameTs: false,
      linkManTs: false,
      addressTs: false,
      pleaseCheked: false,
    };
  },
  created() {
    if (!this.$fn.getUserData() || !this.$fn.getUserData().mobile) {
      this.$router.back();
      return
    }
  },
  methods: {
    back() {
      this.$fn.quit()
      this.$router.back();
    },
    // 提交
    btn: function () {
      if (!this.agreement) {
        this.pleaseCheked = true;
        return;
      }

      if (this.signInInfo.memName == "") {
        this.memNameTs = true;
        return;
      }
      if (this.signInInfo.linkMan == "") {
        this.linkManTs = true;
        return;
      }

      if (this.signInInfo.address == "") {
        this.addressTs = true;
        return;
      }
      const toast = Toast.loading({
        message: '注册中...',
        forbidClick: true,
        duration: 0,
        loadingType: 'spinner',
      });
      this.$ajax("/iap-api/wan4/myRegInfoCommit.do", this.signInInfo).then(
        () => {
          toast.clear()
          //注册成功刷新下用户信息
          this.$fn.run(() => {
            if (window.history.length > 1) {
              this.$router.go(-2);
            } else {
              this.$router.replace("/");
            }
          })
        }, () => {
          toast.clear()
        }
      );
    },
  },
};
</script>

<style scoped lang="less">
.registration {
  position: relative;
  font-size: 0;
  overflow-y: scroll;
  min-height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  background: linear-gradient(192deg, #ffddd2 0.18%, #fff 41.29%);

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    display: inline-block;
    width: 100%;
    height: 450px;
    background: url("https://xhdata.wan4.com/dlz-bgc-h450.png") no-repeat center center;
    background-size: auto 450px;
  }

  .header {
    .back {
      position: relative;
      height: 88px;
      line-height: 88px;
      z-index: 999;

      div {
        position: absolute;
        bottom: 24px;
        left: 36px;
        width: 96px;
        height: 40px;
        line-height: 40px;
        text-align: right;
        background: url("https://xhdata.wan4.com/arrow-left-w40.png") no-repeat left center;
        background-size: 40px auto;
        // background-color: #00cd0c;
        vertical-align: middle;
        color: #999;
        font-size: 28px;
      }

      p {
        text-align: center;
        font-size: 32px;
        font-weight: 600;
        color: #333;
      }
    }

    .tips {
      margin-left: 56px;
      margin-top: 80px;
      color: #ff6634;
      font-weight: 600;

      div {
        font-size: 52px;
      }

      p {
        margin-right: 14px;
        font-size: 32px;
      }
    }
  }

  .zhuce-box {
    margin-top: 120px;
    padding: 0 75px;
    display: flex;
    flex-direction: column;

    >span {
      color: #1d2129;
      font-size: 28px;
      line-height: 48px;
      position: relative;
      padding-left: 25px;
      font-weight: 600;

      &::before {
        content: "*";
        color: #e64340;
        font-size: 28px;
        display: inline-block;
        width: 20px;
        height: 136px;
        font-weight: 600;
        position: absolute;
        left: 0;
        top: 0;
      }
    }

    .input-box {
      position: relative;
      margin-top: 16px;
      margin-bottom: 40px;
      max-height: 96px;
      display: flex;

      &:last-child {
        margin-bottom: 0;
      }

      .vux-x-input {
        border: 2px solid #dcdcdc;
        height: 100%;
        font-size: 28px;
        padding: 28px 32px !important;
        width: 100%;
        border-radius: 8px;
      }

      .errorTips {
        border: solid 2px #f53f3f !important;
      }
    }
  }

  .bottom-box {
    margin: 80px 55px 0;
    display: flex;
    flex-direction: column;

    .please-checked {
      font-size: 20px;
      padding-left: 50px;
      color: #f53f3f;
      margin-top: 6px;
    }

    .xy-box {
      margin-top: 20px;
      font-size: 24px;
      height: 28px;
      line-height: 28px;
      color: #999;

      b {
        box-sizing: border-box;
        height: 28px;
        display: inline-block;
        width: 28px;
        background: url("https://xhdata.wan4.com/unchecked-w28.png") no-repeat;
        background-size: 100% 100%;
        border-radius: 50%;
        vertical-align: top;
        margin-right: 16px;
      }

      b.on {
        background: url("https://xhdata.wan4.com/checked-w28.png") no-repeat center center;
        background-size: 28px auto;
      }

      a,
      i {
        color: #ff6634;
      }
    }

    .btn-login {
      height: 104px;
      width: 100%;
      border-radius: 8px;
      font-size: 32px;
      font-style: normal;
      font-weight: bold;
    }
  }

}
</style>
